import type { CreditScoreRange } from '@thesavingsgroup/rate-table/types/CreditScoreRange';
import type { LoanTerm } from '@thesavingsgroup/rate-table/types/LoanTerm';
import type { LoanType } from '@thesavingsgroup/rate-table/types/LoanType';

export const DEFAULT_LOAN_TYPE = 'refinance' as LoanType;
export const DEFAULT_CREDIT_SCORE_RANGE = '670-739' as CreditScoreRange;
export const DEFAULT_LOAN_TERM = '84' as LoanTerm;
